var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-data-card" },
    [
      _vm.icon || _vm.fallback
        ? _c("AppImage", {
            staticClass: "app-data-card__icon",
            attrs: { src: _vm.icon, fallback: _vm.fallback }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-data-card__details" }, [
        _vm.value
          ? _c("div", { staticClass: "app-data-card__value" }, [
              _vm._v(_vm._s(_vm.value))
            ])
          : _c("div", { staticClass: "app-data-card__name" }, [
              _vm._v(_vm._s(_vm.noDisplay ? "" : _vm.$t("no_data")))
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "app-data-card__name" }, [
          _vm._v(_vm._s(_vm.name))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "app-data-card__description" },
          [
            _vm.descriptionIcon
              ? _c("AppImage", {
                  staticClass: "app-data-card__description_icon",
                  attrs: { src: _vm.descriptionIcon }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.description))])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28ccb5be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ccb5be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppDataCard.vue
// module id = null
// module chunks = 